import React from "react";

function DownloadIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 19.575C5.45 19.575 4.97933 19.3793 4.588 18.988C4.19667 18.5967 4.00067 18.1257 4 17.575V15.575C4 15.2917 4.096 15.0543 4.288 14.863C4.48 14.6717 4.71733 14.5757 5 14.575C5.28267 14.5743 5.52033 14.6703 5.713 14.863C5.90567 15.0557 6.00133 15.293 6 15.575V17.575H18V15.575C18 15.2917 18.096 15.0543 18.288 14.863C18.48 14.6717 18.7173 14.5757 19 14.575C19.2827 14.5743 19.5203 14.6703 19.713 14.863C19.9057 15.0557 20.0013 15.293 20 15.575V17.575C20 18.125 19.8043 18.596 19.413 18.988C19.0217 19.38 18.5507 19.5757 18 19.575H6ZM11 7.42502L9.125 9.30002C8.925 9.50002 8.68767 9.59601 8.413 9.58801C8.13833 9.58001 7.90067 9.47568 7.7 9.27501C7.51667 9.07502 7.42067 8.84168 7.412 8.57502C7.40333 8.30835 7.49933 8.07502 7.7 7.87502L11.3 4.27501C11.4 4.17502 11.5083 4.10435 11.625 4.06302C11.7417 4.02168 11.8667 4.00068 12 4.00002C12.1333 3.99935 12.2583 4.02035 12.375 4.06302C12.4917 4.10568 12.6 4.17635 12.7 4.27501L16.3 7.87502C16.5 8.07502 16.596 8.30835 16.588 8.57502C16.58 8.84168 16.484 9.07502 16.3 9.27501C16.1 9.47501 15.8627 9.57935 15.588 9.58801C15.3133 9.59668 15.0757 9.50068 14.875 9.30002L13 7.42502V14.575C13 14.8583 12.904 15.096 12.712 15.288C12.52 15.48 12.2827 15.5757 12 15.575C11.7173 15.5743 11.48 15.4783 11.288 15.287C11.096 15.0957 11 14.8583 11 14.575V7.42502Z"
        fill="black"
      />
    </svg>
  );
}

export default DownloadIcon;
